import { Injectable } from '@angular/core';
declare let THREE: any;
import { ObjectCheckerService } from './object-checker.service';
import { StageService } from './stage.service';

@Injectable()
export class Object3DcloneService {

  constructor(
    protected objectCheckerSrvc: ObjectCheckerService,
    protected stage?: StageService
  ) { }


  clone(selectedObj) {

      // var obj3D = selectedObj.getObjectByName('3D'),
      var obj3D = selectedObj,
        newObj = obj3D.clone(),
        entity = selectedObj.userData.entity;

     // newObj.material = obj3D.material.clone();
      newObj.userData.wall = selectedObj.userData.wall;

      var quaternion = selectedObj.getWorldQuaternion();

      var rotation = new THREE.Euler().setFromQuaternion(quaternion, 'XYZ');

      return {
        mesh: newObj,
        rotation: rotation
      };

  }

}



// WEBPACK FOOTER //
// ./src/app/services/object3-dclone.service.ts